import { colors } from '@ardoq/design-tokens';
import { ARDOQ_DEFAULT_FONT_FAMILY } from '@ardoq/typography';
import { HtmlCanvasVisual, IRenderContext, Rect } from '@ardoq/yfiles';
import { CanvasRenderingContext } from 'tabview/canvasRendering/types';
import { DEFAULT_MULTI_LABEL_STYLE, MultiLabelStyle } from '@ardoq/graph';
import { fillAndStrokeWithShadowLayers, shadowLayers } from 'tabview/utils';

class CanvasOtherLabelVisual extends HtmlCanvasVisual {
  constructor(
    private container: Rect,
    private rects: Rect[],
    private lines: string[][],
    private fontSize: number,
    private lineHeight: number,
    private opacity: number,
    private styles: MultiLabelStyle[]
  ) {
    super();
  }

  render(_: IRenderContext, ctx: CanvasRenderingContext): void {
    const a = ctx.globalAlpha;
    ctx.globalAlpha = this.opacity;
    ctx.fillStyle = colors.white950;
    ctx.font = `${this.fontSize}px ${ARDOQ_DEFAULT_FONT_FAMILY}`;
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.lineWidth = 1;

    const x = this.container.x;
    const w = this.container.width;
    const cx = this.container.centerX;

    for (let i = 0; i < this.rects.length; i++) {
      const style = this.styles[i] ?? DEFAULT_MULTI_LABEL_STYLE;

      const r = this.rects[i];
      const y = this.container.y + r.y;
      const h = r.height;

      const buildPath = () => {
        ctx.beginPath();
        ctx.roundRect(x, y, w, h, 4);
      };

      fillAndStrokeWithShadowLayers(
        ctx,
        shadowLayers,
        style.fillStyle,
        style.strokeStyle,
        buildPath
      );

      const ls = this.lines[i] ?? [];
      const firstLineY =
        y + (h - ls.length * this.lineHeight) / 2 + this.lineHeight / 2;
      ctx.fillStyle = colors.black950;
      for (let j = 0; j < ls.length; j++) {
        ctx.fillText(ls[j], cx, firstLineY + j * this.lineHeight);
      }
    }
    ctx.globalAlpha = a;
  }
}

export { CanvasOtherLabelVisual };
